import { useRegisterEvents, useSigma } from "@react-sigma/core";
import { FC, PropsWithChildren, useEffect } from "react";

function getMouseLayer() {
  return document.querySelector(".sigma-mouse");
}

const GraphEventsController: FC<PropsWithChildren<{ setHoveredNode: (node: string | null) => void }>> = ({
  setHoveredNode,
  children,
}) => {
  const sigma = useSigma();
  const graph = sigma.getGraph();
  const registerEvents = useRegisterEvents();

  useEffect(() => {
    registerEvents({
      clickNode({ node }) {
        if (!graph.getNodeAttribute(node, "hidden")) {
          // Instead of opening a URL, we'll log connected nodes
          const connectedNodes = graph.neighbors(node);
          console.log("Connected Nodes:", connectedNodes);

          // Highlight connected nodes
          connectedNodes.forEach((neighborId) => {
            graph.setNodeAttribute(neighborId, "highlighted", true);
          });

          // Refresh the graph to apply changes
          sigma.refresh();
        }
      },
      doubleClickNode({ node }) {
        if (!graph.getNodeAttribute(node, "hidden")) {
          // You can add specific behavior for double-click if needed
          console.log("Double-clicked node:", node);
        }
      },
      enterNode({ node }) {
        setHoveredNode(node);
        const mouseLayer = getMouseLayer();
        if (mouseLayer) mouseLayer.classList.add("mouse-pointer");
      },
      leaveNode() {
        setHoveredNode(null);
        const mouseLayer = getMouseLayer();
        if (mouseLayer) mouseLayer.classList.remove("mouse-pointer");
      },
    });
  }, [registerEvents, graph, setHoveredNode, sigma]);

  return <>{children}</>;
};

export default GraphEventsController;
